import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    downloadTemplate: 'Download this template',
  },
  fr: {
    downloadTemplate: 'Télécharger le modèle',
  },
} as const);
